import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { Navigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { toast } from 'react-toastify';
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import authService from "../services/auth.service";

const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                This field is required!
            </div>
        );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
            <div className="alert alert-danger" role="alert">
                Email non valide.
            </div>
        );
    }
};

const vusername = value => {
    if (value.length < 3 || value.length > 20) {
        return (
            <div className="alert alert-danger" role="alert">
                The username must be between 3 and 20 characters.
            </div>
        );
    }
};

const vpassword = value => {
    if (value.length < 6 || value.length > 40) {
        return (
            <div className="alert alert-danger" role="alert">
                The password must be between 6 and 40 characters.
            </div>
        );
    }
};

export default class Register extends Component {
    constructor(props) {
        super(props);
        this.handleAction = this.handleAction.bind(this);
        this.handleOptionChangeRole = this.handleOptionChangeRole.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.selectInfo = this.selectInfo.bind(this);
        this.handleOptionChangeService = this.handleOptionChangeService.bind(this);

        this.state = {
            username: "",
            email: "",
            password: "",
            successful: false,
            message: "",
            redirect: null,
            currentUser: { username: "" },
            updateUser:"",
            labelButton:"Ajouter",
            roles:"",
            labelRole:"",
            roleConnect:"",
            services:""
        };
    }

    onChangeUsername(e) {
        this.setState({
            username: e.target.value
        });
    }

    onChangeEmail(e) {
        this.setState({
            email: e.target.value
        });
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }
    handleOptionChangeRole(e){
        this.setState({
            roles: e.target.value
        });
    }

    handleOptionChangeService(e){
        this.setState({
            services: e.target.value
        });
    }
    selectInfo(userId){
        UserService.getUser(userId).then(
            response => {
                this.setState({
                    username: response.data.userName,
                    email: response.data.email,
                    roles:response.data.roles[0],
                    services:response.data.service,
                    labelRole: response.data.roles[0] === "ROLE_CUSTOMER" ? "Client" : (response.data.roles[0] === "ROLE_ADMIN" ? "Admin" : (response.data.roles[0] === "ROLE_SUPER_AGENT" ? "Superviseur agent interne" : "Agent interne" )),
                    labelButton: "Modifier",
                    updateUser: localStorage.getItem("updateUser")
                });

            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    handleAction(e) {
        e.preventDefault();
        this.setState({
            message: "",
            successful: false
        });

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            if(!this.state.updateUser) {
                UserService.register(
                    this.state.username,
                    this.state.email,
                    this.state.password,
                    [this.state.roles],
                    this.state.services

                ).then(
                    response => {
                        this.setState({
                            message: response.data.message,
                            successful: true,
                            redirect: "/agents"
                        });
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        this.setState({
                            successful: false,
                            message: resMessage
                        });
                    }
                );
            }else{
                UserService.updateUser(
                    this.state.updateUser,
                    this.state.username,
                    this.state.email,
                    this.state.password,
                    [this.state.roles],
                    this.state.services
                ).then(
                    response => {
                        this.setState({
                            message: response.data.message,
                            successful: true,
                            redirect: "/agents"
                        });
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        this.setState({
                            successful: false,
                            message: resMessage
                        });
                    }
                );
                localStorage.setItem("updateUser",null);
            }
        }
    }
    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser || (currentUser.roles[0]!=="ROLE_ADMIN" && currentUser.roles[0]!=="ROLE_SUPER_AGENT")) {
            authService.logout();
        }
        this.setState({ currentUser: currentUser, userReady: true, roleConnect: currentUser.roles[0],services: currentUser.service })
        if(localStorage.getItem("updateUser")) this.selectInfo(localStorage.getItem("updateUser"));
    }
    render() {

        if (this.state.successful) {
            toast.success("L'élément a été sauvegardé avec succès.");
            return <Navigate to={this.state.redirect}/>
        }

        if (this.state.redirect) {
            window.location.replace(this.state.redirect)
        }

        return (
            <div className="col-md-12">
                <div className="card card-container">
                    <img
                        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                        alt="profile-img"
                        className="profile-img-card"
                    />

                    <Form
                        onSubmit={this.handleAction}
                        ref={c => {
                            this.form = c;
                        }}
                    >
                        {!this.state.successful && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="username">Identifiant</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        name="username"
                                        value={this.state.username}
                                        onChange={this.onChangeUsername}
                                        validations={[required, vusername]}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.onChangeEmail}
                                        validations={[required, email]}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password">Mot de passe</label>
                                    <Input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.onChangePassword}
                                        validations={[required, vpassword]}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="role">Rôle</label>
                                    <select
                                        onChange={this.handleOptionChangeRole}
                                        className="form-control"
                                        name="role">
                                        <option value={this.state.roles}>{this.state.labelRole}</option>
                                        <option value="ROLE_AGENT">Agent interne</option>

                                        {
                                            (this.state.roleConnect==="ROLE_ADMIN") &&
                                            <option value="ROLE_SUPER_AGENT">Superviseur agent interne</option>

                                        }

                                        {
                                            (this.state.roleConnect==="ROLE_ADMIN") &&
                                            <option value="ROLE_ADMIN">Admin</option>

                                        }

                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="role">Service</label>
                                    <select
                                        onChange={this.handleOptionChangeService}
                                        className="form-control"
                                        name="services">
                                        <option value={this.state.services}>{this.state.services}</option>
                                        {
                                            (this.state.roleConnect==="ROLE_ADMIN") &&<>
                                            <option value="B2C">B2C</option>
                                            <option value="B2B">B2B</option>
                                            <option value="Tous">Tous</option>
                                            </>

                                        }




                                    </select>
                                </div>

                                <div className="form-group">
                                    <button className="btn-ohm btn btn-primary btn-block">{this.state.labelButton}</button>
                                </div>
                            </div>
                        )}

                        {this.state.message && (
                            <div className="form-group">
                                <div
                                    className={
                                        this.state.successful
                                            ? "alert alert-success"
                                            : "alert alert-danger"
                                    }
                                    role="alert"
                                >
                                    {this.state.message}
                                </div>
                            </div>
                        )}
                        <CheckButton
                            style={{ display: "none" }}
                            ref={c => {
                                this.checkBtn = c;
                            }}
                        />
                    </Form>
                </div>
            </div>
        );

    }
}
